'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (autosizingService, $q) {
  autosizingService.registerDelegate("tlSizeableBlock", function (blockCtrl, $el) {
    var delegate = this;
    var useMaxHeight = $el.attr("use-max-height") != null;
    delegate.refreshWidth = angular.noop;
    delegate.setHeight = function (height) {
      if (useMaxHeight) {
        $el.css({
          "max-height": "".concat(height - 2, "px")
        });
      } else {
        $el.outerHeight(height);
      }
    };
  });
  autosizingService.registerDelegate("tlChart", function (chartCtrl, $el) {
    var delegate = this;
    var highchartCtrl = chartCtrl.getHighchartCtrl();
    highchartCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      highchartCtrl.redraw();
    };
    delegate.setHeight = function (height) {
      // console.log("highchart -> setHeight");
      highchartCtrl.setHeight(height - 2); // TODO : 2 = border ...
    };
  });
  autosizingService.registerDelegate("highchart", function (chartCtrl, $el) {
    var delegate = this;
    chartCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      chartCtrl.redraw();
    };
    delegate.setHeight = function (height) {
      // console.log("highchart -> setHeight");
      chartCtrl.setHeight(height - 2); // TODO : 2 = border ...
    };
  });
  autosizingService.registerDelegate("tlTable", function (tableCtrl, $el) {
    var delegate = this;
    var infiniTableCtrl = tableCtrl.getInfiniTableCtrl();
    infiniTableCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      infiniTableCtrl.refreshColumnsSizing();
    };
    delegate.setHeight = function (height) {
      // border +1...
      infiniTableCtrl.setHeight(height - 4, true);
    };
  });
  autosizingService.registerDelegate("infiniTable", function (tableCtrl, $el) {
    var delegate = this;
    tableCtrl.setAutoResize(false);
    delegate.refreshWidth = function () {
      tableCtrl.refreshColumnsSizing();
    };
    delegate.setHeight = function (height) {
      // console.log("infiniTable -> setHeight");
      tableCtrl.setHeight(height - 2, true);
    };
  });
  autosizingService.registerDelegate("leaflet", function (leafletCtrl, $el) {
    var delegate = this;
    delegate.refreshWidth = function () {
      $q.when(leafletCtrl.getMap()).then(function (map) {
        map.invalidateSize();
      });
    };
    delegate.setHeight = function (height) {
      // console.log("leaflet -> setHeight");
      $el.height(height - 2);
      $q.when(leafletCtrl.getMap()).then(function (map) {
        map.invalidateSize();
      });
    };
  });
  autosizingService.registerDelegate("tlDocumentPreview", function (documentCtrl, $el) {
    var delegate = this;
    delegate.refreshWidth = angular.noop;
    delegate.setHeight = function (height) {
      $el.height(height - 2);
      documentCtrl.setHeight(height - 2);
    };
  });
  autosizingService.registerDelegate("pdfViewer", function (viewerCtrl, $el) {
    var delegate = this;
    delegate.refreshWidth = angular.noop;
    delegate.setHeight = function (height) {
      viewerCtrl.setHeight(height);
    };
  });
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/autosizing/componentTypes.js
// module id = 2917
// module chunks = 13